import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.37 1.634c.894-.845 2.346-.845 3.24 0L16.27 3.2a2.082 2.082 0 010 3.061L5.573 16.366A2.363 2.363 0 013.95 17H.764C.342 17 0 16.677 0 16.278v-3.01c0-.574.241-1.125.672-1.531L11.369 1.634zm2.16 1.02a.797.797 0 00-1.08 0L11.014 4.01l2.74 2.588 1.436-1.356a.694.694 0 000-1.02l-1.66-1.568zm-.857 4.964l-2.74-2.587-8.18 7.726a.701.701 0 00-.225.51v2.29h2.423a.787.787 0 00.541-.212l8.181-7.727z",
		fillRule: "evenodd"
	})
});
export default SvgEdit;
